import { useEffect, useState, type Dispatch, type SetStateAction } from 'react';
import { Link } from 'react-router-dom';

import Input from 'components/form/Input';
import useUserStore from 'store/user';

import CoinIcon from 'assets/images/coin_icon.png';
import CloseIcon from 'assets/images/close_icon.png';
import ChevronRight from 'assets/images/chevron_right.svg?react';

import { ShortenAddr } from '@/lib/Shorten';
import Copy from '../svg/Copy';
import Toast from '@/lib/toast';
import { formatPoint } from '@/utils/format';

import packageJson from '../../../package.json';
interface MenuPropsType {
  setIsOpenMenu: Dispatch<SetStateAction<boolean>>;
}

export default function Menu({ setIsOpenMenu }: MenuPropsType) {
  // store
  const { point, telegramId, walletAddress, myReferralCode } = useUserStore();

  // method
  const closeMenu = () => setIsOpenMenu(false);

  const [showToast, setShowToast] = useState(false);
  const [toastMsg, setToastMsg] = useState('');

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;
    if (toastMsg) {
      setShowToast(true);
      timer = setTimeout(() => {
        setShowToast(false);
        setToastMsg('');
      }, 3000);
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [toastMsg]);

  return (
    <div className="fixed inset-0 z-50 mx-auto max-w-[1024px]">
      {/* Backdrop */}
      <div onClick={closeMenu} className="absolute inset-0 bg-black/60" />

      {/* Drawer Panel */}
      <div className="relative z-10 h-full w-[65%] rounded-r-3xl bg-white">
        <header
          className={`border-b-3 flex h-[64px] w-full items-center justify-between rounded-tr-3xl border-[#7F7F7F] bg-[url(assets/images/background.png)] bg-cover pl-[24px] pr-[30px]`}
        >
          <div className="relative flex">
            <img className="absolute -left-[8px] -top-[2px] h-[35px] w-[30px]" src={CoinIcon} />
            <Input
              className="h-[27px] w-[111px] pr-[9px] text-right text-[16px] font-[800] text-[#FF5019]"
              readOnly
              disabled
              value={formatPoint(point)}
            />
          </div>

          <button onClick={closeMenu}>
            <img className="h-[18px] w-[17px]" src={CloseIcon} />
          </button>
        </header>

        <div className="px-[16px] py-[40px]">
          <ul className="flex flex-col gap-[27px]" role="menu">
            {/* <li>
              <Link
                to="/profile"
                onClick={closeMenu}
                role="menuitem"
                tabIndex={0}
                className="flex items-center gap-[5px]"
              >
                <div className="mb-[3px] h-[8px] w-[8px] rounded-full bg-[#FF4F19]" />
                <h3 className="text-[15px] font-[800] text-[#FF4F19]">PROFILE</h3>
              </Link>
              <ul className="ml-[13px] flex flex-col gap-[9px]">
                <li>
                  <div className="grid grid-cols-2 items-center text-[13px] text-[#4F4F4F]">
                    <div className="flex items-center gap-[2px]">
                      <ChevronRight className="mb-[4px] h-[6px] w-[4px]" />
                      <span>Telegram ID</span>
                    </div>
                    <div className="flex items-center justify-end gap-1 text-right">
                      <span>{telegramId}</span>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="grid grid-cols-2 items-center text-[13px] text-[#4F4F4F]">
                    <div className="flex items-center gap-[2px]">
                      <ChevronRight className="mb-[4px] h-[6px] w-[4px]" />
                      <span>Wallet Address</span>
                    </div>
                    <div className="flex items-center justify-end gap-1 text-right">
                      <span>{ShortenAddr(walletAddress)}</span>
                      <Copy
                        value={walletAddress}
                        className="h-8 w-8 cursor-pointer text-gray-500"
                        setToastMsg={setToastMsg}
                        toastMsg="Wallet address copied!"
                      />
                    </div>
                  </div>
                </li>
                <li>
                  <div className="grid grid-cols-2 items-center text-[13px] text-[#4F4F4F]">
                    <div className="flex items-center gap-[2px]">
                      <ChevronRight className="mb-[4px] h-[6px] w-[4px]" />
                      <span>My Referral Code</span>
                    </div>
                    <div className="flex items-center justify-end gap-1 text-right">
                      <span>{myReferralCode}</span>
                      <Copy
                        value={myReferralCode}
                        className="h-8 w-8 cursor-pointer text-gray-500"
                        setToastMsg={setToastMsg}
                        toastMsg="Your referral code is copied!"
                      />
                    </div>
                  </div>
                </li>
              </ul>
            </li> */}

            <li>
              <Link
                to="/points-earned"
                onClick={closeMenu}
                className="flex items-center gap-[5px] text-[15px] text-[#FF4F19] hover:underline focus:outline-none"
                role="menuitem"
                tabIndex={0}
              >
                <div className="mb-[3px] h-[8px] w-[8px] rounded-full bg-[#FF4F19]" />
                <h3 className="font-[800]">POINTS EARNED</h3>
              </Link>
            </li>

            <li>
              <Link
                to="/earn-more-points"
                onClick={closeMenu}
                className="flex items-center gap-[5px] text-[15px] text-[#FF4F19]"
                role="menuitem"
                tabIndex={0}
              >
                <div className="mb-[3px] h-[8px] w-[8px] rounded-full bg-[#FF4F19]" />
                <h3 className="font-[800]">EARN MORE POINTS</h3>
              </Link>
            </li>

            <li>
              <Link
                to="/my-asset-status"
                onClick={closeMenu}
                className="flex items-center gap-[5px] text-[15px] text-[#FF4F19]"
                role="menuitem"
                tabIndex={0}
              >
                <div className="mb-[3px] h-[8px] w-[8px] rounded-full bg-[#FF4F19]" />
                <h3 className="font-[800]">MY ASSET STATUS</h3>
              </Link>
            </li>

            <li>
              <Link
                to="/profile"
                onClick={closeMenu}
                className="flex items-center gap-[5px] text-[15px] text-[#FF4F19]"
                role="menuitem"
                tabIndex={0}
              >
                <div className="mb-[3px] h-[8px] w-[8px] rounded-full bg-[#FF4F19]" />
                <h3 className="font-[800]">PROFILE</h3>
              </Link>
            </li>

            <li>
              <Link
                to="/spotlight"
                onClick={closeMenu}
                className="flex items-center gap-[5px] text-[15px] text-[#FF4F19]"
                role="menuitem"
                tabIndex={0}
              >
                <div className="mb-[3px] h-[8px] w-[8px] rounded-full bg-[#FF4F19]" />
                <h3 className="font-[800]">SPOTLIGHT</h3>
              </Link>
            </li>
          </ul>
          <div className="absolute bottom-[16px] right-[16px] text-sm text-gray-500">v{packageJson.version}</div>
        </div>
      </div>
      {showToast && (
        <Toast
          message={toastMsg}
          duration={3} // 초 단위
          onClose={() => setShowToast(false)}
        />
      )}
    </div>
  );
}
